import React, { useContext } from 'react';
import { Option } from 'react-bootstrap-typeahead/types/types';
import { Typeahead } from 'react-bootstrap-typeahead';
import { OrderContext } from '../../../context/OrderContext';
import { ICustomFields } from '../../../context/interfaces/IOrder';

const CustomFieldSelect = ({
  id, options, placeholder, isMultiselect,
}: {
  id: string
  options: Array<string>
  placeholder?: string
  isMultiselect?: boolean
}) => {
  const { setCustomField, order: { customFields } } = useContext(OrderContext);

  const existingValue = (customFields as ICustomFields)[id];
  const selected = existingValue && existingValue[0] ? existingValue : [];

  const onChange = (v: Option) => {
    const valueAsArray = v as Array<string>;
    const value = isMultiselect ? valueAsArray : valueAsArray[0];

    const result = {
      target: { name: id, value },
    };

    setCustomField(result);
  };

  return (
    <Typeahead
      id="typeahead-custom-field-dropdown"
      maxResults={500}
      multiple={isMultiselect}
      options={options}
      selected={selected.map((s) => `${s}`)}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default CustomFieldSelect;
